//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getUserInfo } from '@/api/yiliaohuzhu'
import { Dialog } from 'vant'
export default {
  name: 'create',
  props: {},
  data () {
    return {}
  },
  created () {
    this.getUser()
  },
  mounted () { },
  computed: {
    userid () {
      return this.$store.state.user.userid
    }
  },
  methods: {
    // 获取身份证
    getUser () {
      getUserInfo({
        userid: this.userid
      }).then(res => {
        if (!res.obj.idcard) {
          // 身份证判断是否参保
          Dialog.alert({
            message: '没有参保',
            confirmButtonColor: '#4774d1'
          }).then(() => {
            this.$router.push({ name: 'yiliaohuzhuHome' })
          })
        }
      })
    },
    // 跳转新增重大病
    linkmajor () {
      this.$router.push({ name: 'yiliaohuzhuCreate1' })
    },
    // 跳转新增住院
    linkhospital () {
      this.$router.push({ name: 'yiliaohuzhuCreate2' })
    }
  }
}
